import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      toast.success("Password updated. Please log in.");
      navigate("/login", { replace: true });
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6" data-testid="reset-password-page">
      <div className="w-full max-w-md fade-in">
        <div className="card-soft p-8">
          <h1 className="font-heading text-2xl font-medium text-[#2C302E]">Choose a new password</h1>
          {!token ? (
            <div className="mt-4 rounded-xl bg-[#FDF2F0] border border-[#F5D8D4] text-[#8C3A30] text-sm p-3">
              Missing reset token. Please request a new reset link.
            </div>
          ) : (
            <form onSubmit={submit} className="mt-6 space-y-4">
              <input
                type="password"
                required
                minLength={6}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="input-soft"
                data-testid="reset-password-input"
                placeholder="At least 6 characters"
              />
              {error && (
                <div className="rounded-xl bg-[#FDF2F0] border border-[#F5D8D4] text-[#8C3A30] text-sm p-3" data-testid="reset-error">
                  {error}
                </div>
              )}
              <button
                type="submit"
                disabled={loading}
                data-testid="reset-submit-button"
                className="btn-primary w-full"
              >
                {loading ? "Updating…" : "Update password"}
              </button>
            </form>
          )}
          <div className="mt-6 text-sm text-center text-[#59605C]">
            <Link to="/login" className="text-[#4A6148] font-medium hover:underline">Back to login</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
